import { Controller } from "@hotwired/stimulus";
import { Tooltip, Popover } from "bootstrap";
export default class extends Controller {
    connect() {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        [...tooltipTriggerList].map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
        const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
        [...popoverTriggerList].map((popoverTriggerEl) => new Popover(popoverTriggerEl));
    }
}
